import { z } from "zod";

// The Optro record a session's output belongs to, resolved server-side: a
// session's control/work step is a clone and does not reliably carry the
// external ref. Null on the envelope means the session is not linked, or the
// lookup failed (`optroLinkError` on the envelope).
export const OptroLinkSchema = z.object({
  url: z.string(),
  targetType: z.enum(["Test", "OpsAuditItem"]),
  targetId: z.number(),
});

export type OptroLink = z.infer<typeof OptroLinkSchema>;
